import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { getEnvProps } from "@dp/common";
export default function Footer(props) {
  var _getEnvProps = getEnvProps(),
      NEXT_PUBLIC_REACT_APP_BUILD_NUMBER = _getEnvProps.NEXT_PUBLIC_REACT_APP_BUILD_NUMBER;

  return /*#__PURE__*/_jsx(_Fragment, {
    children: NEXT_PUBLIC_REACT_APP_BUILD_NUMBER ? /*#__PURE__*/_jsxs("div", {
      className: props.className,
      children: ["v", NEXT_PUBLIC_REACT_APP_BUILD_NUMBER]
    }) : null
  });
}